module.exports = __webpack_public_path__ + "static/holly-infinite-227d0a9665b3df2f57023a041dede530.jpg";